import cls from "./customHeader.module.scss"
import React, {FC} from "react";
import FirstSection from "./FirstSection";
import SecondSection from "./SecondSection";
import {IFirstHeader, ISecondHeader} from "../MainLayout";
import {useSelector} from "react-redux";
import {IState} from "../../../../types/state";

interface IProps extends IFirstHeader, ISecondHeader {
    isMobile: boolean;
}

const CustomHeader: FC<IProps> = (
    {
        logoPath,
        dbName,
        domain,
        menus,
        hasBlog,
        selectedRate,
        isTwoKings,
        categories,
        selectedLocale,
        translationsData,
        backOrderValue,
        isSocialLinksActive,
        allowCheckoutValue,
        selectedLocaleImg,
        locales,
        cacheControlVersion,
        isMobile,
        showAccount,
        showWishlist,
        showCart,
        showSearch,
        showSecondSection,
        defaultLangCode,
        themeOptions,
        searchShowDetails,
        metas
    }
) => {
    const openSearch = useSelector((state: IState) => state.mobileMenu.searchOpen) || false
    const handleSecondHeader = {
        "SecondSection": <SecondSection
            selectedRate={selectedRate}
            isTwoKings={isTwoKings}
            categories={categories}
            dbName={dbName}
            selectedLocale={selectedLocale}
            translationsData={translationsData}
            backOrderValue={backOrderValue}
            isSocialLinksActive={isSocialLinksActive}
            allowCheckoutValue={allowCheckoutValue}
            showAccount={showAccount}
            showWishlist={showWishlist}
            showCart={showCart}
            showSearch={showSearch}
            showSecondSection="Empty"
            isMobile={isMobile}
            defaultLangCode={defaultLangCode}
            domain={domain}
            searchShowDetails={searchShowDetails}
            metas={metas}
        />,
        "Empty": null
    }
    return <div className={cls.header}>
        <FirstSection
            dbName={dbName}
            domain={domain}
            logoPath={logoPath}
            menus={menus}
            hasBlog={hasBlog}
            selectedLocaleImg={selectedLocaleImg}
            translationsData={translationsData}
            locales={locales}
            cacheControlVersion={cacheControlVersion}
            themeOptions={themeOptions}
        />
        {!isMobile ? handleSecondHeader[showSecondSection] : openSearch ? handleSecondHeader[showSecondSection] : null}
    </div>
};

export default CustomHeader;